import React from 'react';
import { useIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { snakeCase } from 'lodash';
import { managedFieldNames } from 'js/constants';

function SignupFormFields(props) {
  const { updateEntity } = props;
  const { messages } = useIntl();

  const VISIBLE = 'visible';
  const REQUIRED = 'required';
  const registrationVisibleFields = 'registrationVisibleFields';
  const registrationRequiredFields = 'registrationRequiredFields';
  const propertyNames = {
    [VISIBLE]: registrationVisibleFields,
    [REQUIRED]: registrationRequiredFields,
  };

  const fieldNames = Object.fromEntries(managedFieldNames.map(name => [name, messages[snakeCase(name)] ?? name]));

  const addValue = (type, value) => {
    const list = getEntityArray(type);
    if (!list.includes(value)) {
      updateEntity(propertyNames[type], [...list, value]);
    }
  };

  const removeValue = (type, value) => {
    const list = getEntityArray(type);
    if (list.includes(value)) {
      updateEntity(propertyNames[type], list.filter(item => item !== value));
    }
  };

  const updateRegistrationFields = (type, value, event) => {
    const { target } = event;

    if (target?.checked) {
      addValue(type, value);
      if (type === REQUIRED) {
        // also enable the visible, if not already
        addValue(VISIBLE, value);
      }
    } else {
      removeValue(type, value);
      if (type === VISIBLE) {
        // also remove the field from required
        removeValue(REQUIRED, value);
      }
    }
  };

  const getEntityArray = type => {
    let methodName;
    if (type === VISIBLE) {
      methodName = 'getRegistrationVisibleFields';
    } else if (type === REQUIRED) {
      methodName = 'getRegistrationRequiredFields';
    } else {
      return [];
    }

    const { entity } = props;
    const originalArray = entity[methodName]();
    const uniqueArray = Array.from(new Set(originalArray));
    return uniqueArray;
  };

  const isRegistrationFieldChecked = (type, value) => {
    const fieldArray = getEntityArray(type);
    return fieldArray.includes(value);
  };

  const optionRows = type =>
    Object.entries(fieldNames).map(([value, label], i) => {
      const id = `${type}_${i}`;
      const disabled = false;

      return (
        <div className="checkbox check-success" key={id}>
          <input
            disabled={disabled}
            id={id}
            name={`registration${type}Fields[]`}
            type="checkbox"
            value={value}
            checked={isRegistrationFieldChecked(type, value)}
            onChange={event => updateRegistrationFields(type, value, event)}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-for */}
          <label htmlFor={id}>{label}</label>
        </div>
      );
    });

  return (
    <>
      <Row>
        <Col xs={12} md={6}>
          <p>{messages.registration_fields_show}</p>
          {optionRows(VISIBLE)}
        </Col>
        <Col xs={12} md={6}>
          <p>{messages.registration_fields_require}</p>
          {optionRows(REQUIRED)}
        </Col>
      </Row>
    </>
  );
}

export default SignupFormFields;
